import {CommonModule} from '@angular/common';
import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {FilterDateRangeValue, FilterDefinition, FilterValues} from '../../../models/vte';

@Component({
    selector: 'app-filter-bar',
    standalone: true,
    imports: [CommonModule, FormsModule],
    templateUrl: './filter-bar.component.html',
    styleUrl: './filter-bar.component.css',
})
export class FilterBarComponent {
    @Input() filters: FilterDefinition[] = [];
    @Input() values: FilterValues = {};
    @Output() valuesChange = new EventEmitter<FilterValues>();
    @Output() apply = new EventEmitter<FilterValues>();
    @Output() reset = new EventEmitter<void>();

    onValueChange(key: string, value: string | string[] | FilterDateRangeValue | null): void {
        const next = {...this.values, [key]: value};
        this.values = next;
        this.valuesChange.emit(next);
    }

    onSelectChange(key: string, event: Event): void {
        const target = event.target as HTMLSelectElement;
        this.onValueChange(key, target.value || null);
    }

    selectValue(key: string): string {
        const current = this.values[key];
        return typeof current === 'string' ? current : '';
    }

    onSelectModelChange(key: string, value: string): void {
        this.onValueChange(key, value || null);
    }

    onSearchInput(key: string, event: Event): void {
        const target = event.target as HTMLInputElement;
        this.onValueChange(key, target.value);
    }

    dateRangeValue(key: string, part: 'from' | 'to'): string {
        const current = this.values[key];
        if (!current || typeof current !== 'object' || Array.isArray(current)) {
            return '';
        }
        return current[part] || '';
    }

    onDateRangeChange(key: string, part: 'from' | 'to', event: Event): void {
        const target = event.target as HTMLInputElement;
        const current = this.values[key];
        const existing: FilterDateRangeValue =
            current && typeof current === 'object' && !Array.isArray(current)
                ? {...current}
                : {};
        existing[part] = target.value || null;
        this.onValueChange(key, existing);
    }

    isSelected(key: string, optionValue: string): boolean {
        const current = this.values[key];
        if (Array.isArray(current)) {
            return current.includes(optionValue);
        }
        return current === optionValue;
    }

    onMultiselectToggle(key: string, optionValue: string, checked: boolean): void {
        const current = this.values[key];
        const selected = Array.isArray(current) ? [...current] : [];
        const next = checked
            ? Array.from(new Set([...selected, optionValue]))
            : selected.filter((value) => value !== optionValue);
        this.onValueChange(key, next);
    }

    applyFilters(): void {
        this.apply.emit({...this.values});
    }

    resetFilters(): void {
        this.values = {};
        this.valuesChange.emit({});
        this.reset.emit();
    }
}
